"use strict";
/*
 * Copyright 2019 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BalanceChangeReceipt = void 0;

var catbuffer_typescript_1 = require("catbuffer-typescript");

var Receipt_1 = require("./Receipt");

var ReceiptVersion_1 = require("./ReceiptVersion");
/**
 * Balance Change: A mosaic credit or debit was triggered.
 */


var BalanceChangeReceipt = /*#__PURE__*/function (_Receipt_1$Receipt) {
  _inherits(BalanceChangeReceipt, _Receipt_1$Receipt);

  var _super = _createSuper(BalanceChangeReceipt);

  /**
   * Balance change expiry receipt
   * @param targetAddress - The target account address.
   * @param mosaicId - The mosaic id.
   * @param amount - The amount of mosaic.
   * @param version - The receipt version
   * @param type - The receipt type
   * @param size - the receipt size
   */
  function BalanceChangeReceipt(
  /**
   * The target account address.
   */
  targetAddress,
  /**
   * The mosaic id.
   */
  mosaicId,
  /**
   * The amount of mosaic.
   */
  amount, version, type, size) {
    var _this;

    _classCallCheck(this, BalanceChangeReceipt);

    _this = _super.call(this, version, type, size);
    _this.targetAddress = targetAddress;
    _this.mosaicId = mosaicId;
    _this.amount = amount;
    return _this;
  }
  /**
   * @internal
   * Generate buffer
   * @return {Uint8Array}
   */


  _createClass(BalanceChangeReceipt, [{
    key: "serialize",
    value: function serialize() {
      return new catbuffer_typescript_1.BalanceChangeReceiptBuilder(ReceiptVersion_1.ReceiptVersion.BALANCE_CHANGE, this.type.valueOf(), new catbuffer_typescript_1.MosaicBuilder(this.mosaicId.toBuilder(), new catbuffer_typescript_1.AmountDto(this.amount.toDTO())), this.targetAddress.toBuilder()).serialize();
    }
  }]);

  return BalanceChangeReceipt;
}(Receipt_1.Receipt);

exports.BalanceChangeReceipt = BalanceChangeReceipt;